import type { PropsWithChildren } from 'react';

import type { ThemeColorType, ThemeSpaceType } from 'src/styles/theme';

import {
  Body,
  BodyBold,
  Callout,
  CalloutSmall,
  DisplayXL,
  DisplayXXL,
  DisplayXXXL,
  H1,
  H2,
  H3,
  H4,
  Overline,
  Quote,
  Small,
  SmallSpacedOut,
} from './styles';

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'displayXXXL'
  | 'displayXXL'
  | 'displayXL'
  | 'body'
  | 'bodyBold'
  | 'small'
  | 'smallSpacedOut'
  | 'overline'
  | 'callout'
  | 'calloutSmall'
  | 'quote';

export interface TypographyProps
  extends PropsWithChildren<{
    className?: string;
    color?: ThemeColorType;
    marginBottom?: ThemeSpaceType;
    variant: TypographyVariant;
    id?: string;
    [key: `data-${string}`]: any;
  }> {}

const variants = {
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  displayXXXL: DisplayXXXL,
  displayXXL: DisplayXXL,
  displayXL: DisplayXL,
  body: Body,
  bodyBold: BodyBold,
  small: Small,
  smallSpacedOut: SmallSpacedOut,
  overline: Overline,
  callout: Callout,
  calloutSmall: CalloutSmall,
  quote: Quote,
};

export const Typography = ({ children, className, color, marginBottom, variant, id, ...rest }: TypographyProps) => {
  const Component = variants[variant];
  return (
    <Component className={className} color={color} $marginBottom={marginBottom} id={id} {...rest}>
      {children}
    </Component>
  );
};
